declare const window: {
    fbq: any;
};

export function trackEventFbLead(
    category?: any
) {
    if ("fbq" in window) {
        window.fbq('track', "Lead", { content_category: category  });
    }
}